import "./MultiTimeRange.scss";

import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { FaTrash } from "react-icons/fa";

import Button from "../../common/Button/Button";

interface MultiTimeRangeProps {
	className?: string;
	defaultValue?: string[];
	value?: { from: string; to: string }[];
	onChange?: (val: { from?: string; to?: string }[]) => void;
}

const MultiTimeRange: React.FC<MultiTimeRangeProps> = (props) => {
	const { className, value, onChange } = props;
	const [canAddRange, setCanAddRange] = useState(true);

	const addRange = useCallback(() => {
		setCanAddRange(false);

		if (!onChange) {
			return;
		}

		onChange([...(value || []), { from: undefined, to: undefined }]);
	}, [value, onChange]);

	const checkCanAddRange = useCallback((newValue) => {
		const allValuesHaveRange = newValue.every((v: any) => v.from && v.to);
		setCanAddRange(allValuesHaveRange);
	}, []);

	const handleChange = useCallback(
		(evt) => {
			if (!value) {
				return;
			}

			const newValue = [...value];
			const { currentTarget } = evt;

			const valueIndex = Number(currentTarget.id.split("_")[2]);
			const isFrom = currentTarget.id.includes("_start_");

			newValue[valueIndex][isFrom ? "from" : "to"] = currentTarget.value;

			if (onChange) {
				onChange(newValue);
			}

			checkCanAddRange(newValue);
		},
		[value, onChange, checkCanAddRange],
	);

	const onDelete = useCallback(
		(evt) => {
			if (!value) {
				return;
			}

			const { currentTarget } = evt;
			const valueIndex = currentTarget.id.split("_")[2];
			const newValue = [...value];

			newValue.splice(valueIndex, 1);

			if (onChange) {
				onChange(newValue);
			}
		},
		[value, onChange],
	);

	return (
		<div className={"MultiTimeRange"}>
			{(value || []).map((val, index) => {
				return (
					<div className={"MultiTimeRange__inputs"} key={`test_start_${index}`}>
						<div className={"MultiTimeRange__input-container"}>
							<label htmlFor={`range_start_${index}`}>From</label>
							<input
								id={`range_start_${index}`}
								type={"time"}
								className={clsx("Field__input", className)}
								value={val.from}
								onChange={handleChange}
							/>
						</div>

						<div
							className={"MultiTimeRange__input-container"}
							key={`range_end_${index}`}
						>
							<label htmlFor={`range_end_${index}`}>To</label>
							<input
								id={`range_end_${index}`}
								type={"time"}
								className={clsx("Field__input", className)}
								value={val.to}
								onChange={handleChange}
							/>
						</div>

						{index !== 0 ? (
							<FaTrash
								className={"MultiTimeRange__delete"}
								id={`range_delete_${index}`}
								onClick={onDelete}
							/>
						) : (
							<div className={"MultiTimeRange__spacer"}></div>
						)}
					</div>
				);
			})}

			<Button onClick={addRange} disabled={!canAddRange}>
				+ Add
			</Button>
		</div>
	);
};

export default MultiTimeRange;
